<template>
	<div>
		<div class="global-loader">
			<div class="content">
				<img src="/static/assets/img/gloader.svg"/>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'globalLoader',
        data () {
            return {
                msg: ''
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.global-loader {
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		position: fixed;
		overflow-y: auto;
		background-color: rgba(0,0,0,0.6);
		z-index: 10000;
	}
	.content {
		margin: auto;
		margin-top: 40vh;
		width: 20vw;
		height: 10vw;
		text-align: center;
		border-radius: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/components/ui/loader/globalLoader.vue